// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"53508b0d","401":"f7129634","446":"b4226f32","455":"432bb6e5","470":"73d2374a","488":"26e5a9c2","547":"2f46f423","670":"1f510c75","689":"779d69da","786":"d630d74e","788":"8baa037a","857":"f2178ee7","882":"41cb3434","947":"edf7a411"}[chunkId] + ".chunk.js";
};